import store from '@/store/Index.js';

export default (to, from, next) => {
    if (!store.getters['Auth/user'].is_super_admin) {
        next({ name: 'home' });
    } else {
        next();
    }
};
